import * as React from 'react';
import { NotificationDrawer } from '../../containers/notification-drawer/NotificationDrawer';
import { EnvironmentBadge, EnvironmentStrip } from '../environment-badge/EnvironmentBadge';
import { Logo } from '../logo/Logo';
import { HeaderBreadcrumb } from './HeaderBreadcrumb';
import './Header.scss';

// The service center and the person are in the sidebar (see Layout), so the top bar has the page, the environment and
// the drawer of notifications
export const Header = () => (

    <nav className="navbar flex-md-nowrap">
        <EnvironmentStrip />
        <Logo />
        <HeaderBreadcrumb />

        <div className="right-side">
            <EnvironmentBadge />
            <NotificationDrawer />
        </div>

    </nav>

);
